import type { RawAttributeAggregations } from "@jti/commerce/features";

import { createSafeContentWithData } from "@/libs/builder/tools/createSafeContentWithData/createSafeContentWithData";
import type { ColorVariant } from "@/libs/commerce/products";

const { Content, createDefaultDataBindings } = createSafeContentWithData<{
  categoryName: string;
  categoryItems: {
    name: string;
    sku: string;
    url_key: string;
    thumbnailSrc: string;
    shortDescription?: string;
    colors?: ColorVariant[];
  }[];
  categoryFilters: {
    name: string;
    uid: string;
    checked: boolean;
    productCount: number;
  }[];
  subcategoriesMap: Record<string, string[]>;
  selectedRegion?: string;
  attributeAggregations: RawAttributeAggregations;
}>();

export { Content, createDefaultDataBindings };
